import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from 'redux/sagas/auth/selectors';

import useCountryByIp from 'utils/hooks/useCountryByIp';

import { COUNTRY_CODES } from 'utils/constants';

export default function useAuUser() {
  const user = useSelector(getUser);

  const countryByIp = useCountryByIp();

  return useMemo(
    () =>
      user.country === COUNTRY_CODES.AU ||
      (!user.country && countryByIp?.countryCode === COUNTRY_CODES.AU),
    [countryByIp?.countryCode, user],
  );
}
